import UserManagementUserListSlice from '../../slices/experiences/UserManagementUserListSlice'
import USER_MANAGEMENT_EXPERIENCE_TYPES from '../../types/experiences/UserManagement'
import { makeActionCreator } from '../../../modules/utilities/store'
import UserManagementUserListExportSlice from '../../slices/experiences/UserManagementUserListExportSlice'
import UserManagementUserActionListSlice from '../../slices/experiences/UserManagementUserActionListSlice'
import UserManagementUserActionListExportSlice from '../../slices/experiences/UserManagementUserActionListExportSlice'

const UserManagementExperienceActions = {
  list: UserManagementUserListSlice.actions,
  exportList: UserManagementUserListExportSlice.actions,
  actionList: UserManagementUserActionListSlice.actions,
  exportActionList: UserManagementUserActionListExportSlice.actions,
  /**
   * @param userItem {StoreUser}: StoreUser instance containing edited user data.
   * @param onSuccess {function}: executed if creation was successful.
   * @returns {{ type: string, data: { userItem: StoreUser, onSuccess: function } }}
   */
  create: makeActionCreator(USER_MANAGEMENT_EXPERIENCE_TYPES.CREATE, 'userItem', 'onSuccess', 'photoId'),
  /**
   * @param userItem {StoreUser}: StoreUser instance containing edited user data.
   * @param onSuccess {function}: executed if editing was successful.
   * @returns {{ type: string, data: { userItem: StoreUser, onSuccess: function } }}
   */
  edit: makeActionCreator(USER_MANAGEMENT_EXPERIENCE_TYPES.EDIT, 'userItem', 'onSuccess'),
  /**
   * @param userId {string}
   * @param password {string}
   * @param onSuccess {function}
   * @returns {{ type: string, data: { userId: string, password: string, onSuccess: function } }}
   */
  changePassword: makeActionCreator(
    USER_MANAGEMENT_EXPERIENCE_TYPES.CHANGE_PASSWORD,
    'userId',
    'password',
    'onSuccess'
  ),
  /**
   * Partial user update for access policy fields (saved immediately from the edit UI).
   * @param userId {string}
   * @param patch {object} e.g. { areFormFillsMandatory: true } or { twoFactorAuthEnabled: false }
   */
  patchPolicy: makeActionCreator(
    USER_MANAGEMENT_EXPERIENCE_TYPES.PATCH_POLICY,
    'userId',
    'patch'
  ),
  /**
   * Assign profile photo to a user (saved immediately from the profile photo card).
   * @param userId {string}
   * @param photoId {string}
   */
  patchPhoto: makeActionCreator(
    USER_MANAGEMENT_EXPERIENCE_TYPES.PATCH_PHOTO,
    'userId',
    'photoId'
  ),
  /**
   * @param userId {string}
   * @param isActive {boolean}
   * @returns {{ type: string, data: { userId: string, isActive: boolean } }}
   */
  updateAttributeActive: makeActionCreator(
    USER_MANAGEMENT_EXPERIENCE_TYPES.UPDATE_ATTRIBUTE_ACTIVE,
    'userId',
    'isActive'
  ),
  /**
   * @param userId {string}: id of user to delete.
   * @returns {{ type: string, data: { userId: string } }}
   */
  delete: makeActionCreator(USER_MANAGEMENT_EXPERIENCE_TYPES.DELETE, 'userId')
}

export default UserManagementExperienceActions
